import { useEffect, useState } from 'react';
import { Megaphone, X } from 'lucide-react';
import api from '@/services/apiClient';
import styles from './CampaignBanner.module.css';

const DISMISS_KEY = 'movez_dismissed_campaigns';

const loadDismissed = () => {
  try {
    return JSON.parse(localStorage.getItem(DISMISS_KEY) || '[]');
  } catch {
    return [];
  }
};

/**
 * Banner de campanhas ativas no topo dos dashboards. Busca GET /campaigns/active,
 * exibe o primeiro banner não dispensado e nada quando vazio. Dispensável (persiste por id).
 */
export default function CampaignBanner() {
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get('/campaigns/active')
      .then((res) => {
        if (!alive) return;
        const list = (res.data || res).campaigns || [];
        const dismissed = loadDismissed();
        const next = list.find((c) => !dismissed.includes(String(c.id)));
        setCampaign(next || null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!campaign) return null;

  const text = campaign.bannerText || campaign.description || campaign.name;

  const dismiss = () => {
    const dismissed = loadDismissed();
    dismissed.push(String(campaign.id));
    try {
      localStorage.setItem(DISMISS_KEY, JSON.stringify(dismissed));
    } catch {
      /* ignore */
    }
    setCampaign(null);
  };

  return (
    <div className={styles.banner}>
      <Megaphone size={16} strokeWidth={2} className={styles.icon} />
      <div className={styles.text}>
        <span className={styles.name}>{campaign.name}</span>
        {text && text !== campaign.name && <span className={styles.body}>{text}</span>}
        {campaign.discountPct != null && (
          <span className={styles.discount}>-{campaign.discountPct}%</span>
        )}
      </div>
      <button type="button" className={styles.close} onClick={dismiss} aria-label="dismiss">
        <X size={16} strokeWidth={2} />
      </button>
    </div>
  );
}
